module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bc-sched"
  }, [_c('div', {
    staticClass: "bc-sched__inner"
  }, [_c('h1', {
    staticClass: "bc-sched__title"
  }, [_vm._v(_vm._s(_vm.$T('官网资料页标题')))]), _vm._v(" "), _c('p', {
    staticClass: "bc-sched__desc"
  }, [_vm._v(_vm._s(_vm.$T('官网资料页说明')))]), _vm._v(" "), _c('ul', {
    staticClass: "bc-sched__list"
  }, _vm._l((_vm.docs), function(doc) {
    return _c('li', {
      key: doc.id,
      staticClass: "bc-sched__item"
    }, [_c('div', {
      staticClass: "bc-sched__meta"
    }, [_c('h2', {
      staticClass: "bc-sched__name"
    }, [_vm._v(_vm._s(_vm.$T(doc.titleKey)))]), _vm._v(" "), _c('p', {
      staticClass: "bc-sched__file"
    }, [_vm._v(_vm._s(doc.fileName))])]), _vm._v(" "), _c('a', {
      staticClass: "bc-sched__btn",
      attrs: {
        "href": doc.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$T('官网资料查看下载')) + "\n        ")])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a3dfdac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/ScheduleDocs.vue
// module id = 1467
// module chunks = 0